import script from "./FormErrorToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormErrorToast.vue?vue&type=script&setup=true&lang=ts"

import "./FormErrorToast.vue?vue&type=style&index=0&id=2cbb9de2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbb9de2"]])

export default __exports__